import {
  Badge,
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography
} from '@mui/material'
import React, { useMemo } from 'react'
import { TextForm } from '../../../components/TextBox'
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import SelectForm from '../../../components/SelectBox/SelectForm';
import DateForm from '../../../components/SelectBox/DateForm';
import AutocompleteMultiForm from '../../../components/SelectBox/AutocompleteMultiForm';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, offNextButton } from '../../../store/slice/buttonSlice';
import { useState } from 'react';
import AutocompleteTextForm from '../../../components/TextBox/AutocompleteTextForm';
import { useGetSupplierQuery, usePostSupplierMutation } from '../../../store/api/supplierEvaluationApi';
import SaveDialog from '../../../components/Dialog/SaveDialog';
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../constToast/constToast';
import { toggleUploadDialog } from '../../../store/slice/dialogSlice';
import { CloudDownload } from '@mui/icons-material';
import RadioFormBool from '../../../components/Checkbox/RadioFormBool';
import CompanyDealerAttachment from './CompanyDealerAttachment';
import CompanyLogoAttachment from './CompanyLogoAttachment';
import SupLoading from '../../../components/Loading/SupLoading';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { updateSupNextButtonLoading } from '../../../store/slice/otherSlice';
import { useTranslation } from 'react-i18next';
import ReactInputMask from 'react-input-mask';
import TextPhone from '../../../components/TextBox/TextPhone';
import { usePostVendorByTaxMutation } from '../../../store/api/vendorApi';
import { usePostUserSendToApproveMutation } from '../../../store/api/userApi';

export default function CompanyInformationSup({ companyData, setCompanyData, attachmentsDealership, setAttachmentsDealership,
  companyLogo, setCompanyLogo,
  vendorId, setVendorId, createSup, reviseSup }) {
  const dispatch = useDispatch();

  const [openAttachmentDialog, setOpenAttachmentDialog] = useState(false)
  const { handleSubmit, control, reset, formState: { errors, isValid }, setValue, watch } = useForm({ mode: 'onBlur' });
  const [saveMutation] = usePostSupplierMutation();

  const { data, refetch, isLoading } = useGetSupplierQuery(vendorId);

  const { dataId } = useParams()
  const individualBool = useSelector(state => state.otherSlice.individualBool)

  useEffect(() => {
    if (Object.values(companyData)?.length === 0) {
      reset({
        ...data?.data?.contactPerson,
        ...data?.data?.companyInformation,
      })
      if (createSup || dataId === '0') {
        setValue('email', '')
        setValue('contactPerson', '')
      }
      setValue('agreeWithDefaultDays', true)
    } else {
      reset({
        ...data?.data?.contactPerson,
        ...data?.data?.companyInformation,
        ...companyData,
      })

    }
  }, [reset, data, companyData, setValue, createSup, dataId])


  useEffect(() => {
    if (Object.values(companyData)?.length === 0) {
      setAttachmentsDealership(data?.data?.companyInformation?.attachments)
    }
    else {
      setAttachmentsDealership(attachmentsDealership)
    }
  }, [data, companyData, setAttachmentsDealership])

  useEffect(() => {
    if (Object.values(companyData)?.length === 0) {
      setCompanyLogo(data?.data?.companyInformation?.companyLogo)
    }
    else {
      setCompanyLogo(companyLogo)
    }
  }, [data, companyData, setCompanyLogo])


  const open = useSelector((state) => state.dialogSlice.saveDialog)

  const onSubmit = async (data) => {
    setCompanyData({
      ...data,
      attachments: attachmentsDealership,
      companyLogo: companyLogo,
    })

    if (!open) {
      dispatch(nextStep())
    } else {
      const saveData = await saveMutation({
        companyInformation: {
          ...data,
          attachments: attachmentsDealership,
          companyLogo: companyLogo,
          vendorId: reviseSup ? 0 : vendorId
        }, isRevise: reviseSup
      });

      if (saveData?.data?.statusCode === 200) {
        showSuccessToast(`Succesfully saved`)
        setCompanyData(saveData?.data?.data?.companyInformation)
        setVendorId(saveData?.data?.data?.companyInformation?.vendorId)
        refetch()
      } else { showErrorToast('Error') }
    }
  }
  let xlColumn, lgColumn, mdColumn, smColumn, xsColumn;

  //Column
  xlColumn = 3;
  lgColumn = 3;
  mdColumn = 4;
  smColumn = 6;
  xsColumn = 12;

  const [disabled, setDisabled] = useState(true)

  const radioWatch = watch('agreeWithDefaultDays')

  useEffect(() => {
    if (radioWatch === true) {
      setDisabled(true)
      setValue('creditDays', 60)
    } else {
      setDisabled(false)
    }
  }, [radioWatch, setValue])


  const nextClicked = useSelector((state) => state.buttonSlice.nextClicked)

  useEffect(() => {
    if (nextClicked) {
      handleSubmit(onSubmit)()
      dispatch(offNextButton())
      if (isValid) {
        dispatch(updateSupNextButtonLoading(true))
      }
    }
  }, [nextClicked, dispatch])


  // FILTER DATA
  const filteredBusinessSectorIds = watch('businessSectors')?.map(x => x.businessSectorId)

  // Configuration
  const filteredBusinessCategories = data?.data?.businessCategories?.filter(item => filteredBusinessSectorIds?.includes(item.businessSectorId));

  const filteredBusinessCategoriesIds = watch('businessCategories')?.map(x => x.id)
  const filteredProductServices = data?.data?.services?.filter(item => filteredBusinessCategoriesIds?.includes(item.businessCategoryId));

  useEffect(() => {
    if (!isLoading) {
      dispatch(updateSupNextButtonLoading(false))
    }
  }, [isLoading, dispatch])

  const { t } = useTranslation('supplier')

  const [postVendorByTax] = usePostVendorByTaxMutation();
  const [taxDialog, setTaxDialog] = useState(false)


  const handleTaxBlur = async (value) => {
    const data = await postVendorByTax(value);
    if (data?.data?.vendorId !== 0) {
      setTaxDialog(true)
    }
  };
  const handleTaxCloseDialog = () => {
    setTaxDialog(false);
    setValue('taxId', '')
  }

  const [postTax] = usePostUserSendToApproveMutation();
  const readSup = useSelector(state => state.otherSlice.readSup)
  const navigate = useNavigate();
  const handleYesTax = () => {
    postTax();
    navigate('/waiting')
  }

  return (
    <>

      {!isLoading ? (<>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid container spacing={2} display='flex' justifyContent='space-between' alignItems='center'>

            {/* Company Information */}
            <Grid item xs={12}>
              <Typography variant='h4' mb={1}>{t('company_information')}</Typography>
              <Divider />
            </Grid>

            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextForm label={t('email')} dynamicField='email'
                control={control} errors={errors}
                required={true}
              />
            </Grid>

            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextForm label={t('full_name')} dynamicField='contactPerson'
                control={control} errors={errors}
                required={true}
                min={3} max={40}
              />
            </Grid>

            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextPhone
                control={control}
                dynamicField="phoneNo"
                label={t('contact_phone')}
                required={true}
                errors={errors}
                minDigits={12}
              />
            </Grid>
            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextForm label={t('company_legal_name')} dynamicField='companyName'
                control={control} errors={errors}
                required={true}
                min={3} max={40}
              />
            </Grid>
            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextForm label={t('taxId')} dynamicField='taxId'
                control={control} errors={errors}
                required={true}
                min={3} max={40}
                disabled={reviseSup || readSup}
                onBlur={(e) => handleTaxBlur(e.target.value)}
              />
            </Grid>

            {/* Configuration */}
            {/* <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <TextForm label='Tax Office' dynamicField='taxOffice'
                control={control} errors={errors}
                required={true}
                min={3} max={40}
              />
            </Grid> */}

            {!individualBool && <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn} >
              <TextForm label={t('address')} dynamicField='companyAdress'
                control={control} errors={errors}
                required={true}
                min={3} max={90}
              />
            </Grid>}
            <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <SelectForm label={t('country')} id='countryCode' name='countryName'
                control={control} errors={errors} disabled={false}
                data={data?.data?.countries} dynamicField='country' required={true} />
            </Grid>
            {!individualBool && <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn} >
              <TextForm label={t('city')} dynamicField='city'
                control={control} errors={errors}
                required={true}
                min={3} max={40}
              />
            </Grid>}
            {!individualBool &&
              <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn} >
                <TextForm label={t('website')} dynamicField='webSite'
                  control={control} errors={errors}
                  required={false}
                  min={3} max={40}
                />
              </Grid>}

            {/* Configuration */}
            {/* <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
              <DateForm label='Registration Date' dynamicField='registrationDate'
                control={control} errors={errors} required={true} />
            </Grid> */}


            {/* Configuration */}
            {/* <Grid item xs={12} sm={5.67}>
              <AutocompleteMultiForm data={data?.data?.prequalificationTypes} errors={errors}
                label='Prequalification Types' dynamicField='prequalificationTypes' name='category' id='id'
                control={control} required={true} />
            </Grid> */}

            {/* Configuration */}
            {/* <Grid item xs={12} sm={5.67}>
              <AutocompleteMultiForm data={data?.data?.businessSectors} errors={errors}
                label='Business Sectors' dynamicField='businessSectors' name='businessSectorName' id='businessSectorId'
                control={control} required={true}
                onChange={e => {
                  setValue('businessSectors', e)
                  setValue('businessCategories', watch('businessCategories')?.filter(category => e?.some(sector => sector.businessSectorId === category.businessSectorId)))
                }} />
            </Grid> */}

            {/* Configuration */}
            {/* <Grid item xs={12} sm={5.67}>
              <SelectForm label='Payment Terms' id='analysisCode' name='analysisName'
                control={control} errors={errors} disabled={false}
                data={data?.data?.paymentTerms} dynamicField='paymentTerms' required={true} />
            </Grid> */}

            {/* Configuration */}
            <Grid item xs={12} sm={5.67}>
              <AutocompleteMultiForm data={data?.data?.businessCategories} errors={errors}
                label={t('business_categories')} dynamicField='businessCategories' name='name' id='id'
                control={control} required={true}
                onChange={e => {
                  setValue('businessCategories', e)
                  setValue('services', watch('services')?.filter(service => e?.some(category => category.id === service.businessCategoryId)))
                }} />
            </Grid>

            {watch('services')?.some(item => item.id === 43) ?
              <Grid item xs={12} sm={5.67}>
                <TextForm label={t('other')} dynamicField='other'
                  control={control} errors={errors}
                  required={true}
                />
              </Grid> : <></>}

            {!individualBool &&
              <Grid item xs={12} sm={5.67}>
                <AutocompleteTextForm control={control} dynamicField='representedProducts'
                  errors={errors} required={true} label={t('represented_products')} />
              </Grid>
            }


            <Grid item xs={12} sm={5.67}>
              <AutocompleteMultiForm data={filteredProductServices} errors={errors}
                label={t('products')} dynamicField='services' name='name' id='id'
                control={control} required={true} />
            </Grid>

            {!individualBool &&
              <Grid item xs={12} sm={5.67}>
                <AutocompleteTextForm control={control} dynamicField='representedCompanies'
                  errors={errors} required={false} label={t('represented_companies')} />
              </Grid>
            }
            {/* Configuration */}
            {/* <Grid item xs={12} sm={5.67}>
              <Box display='flex' alignItems='center'>
                Dealership / Distributorship / Channel Partnership Agreement(s) Official Letter(s):
                <Badge badgeContent={attachmentsDealership?.filter((x) => x.type === 0)?.length} color="error">
                  <Button size='small' sx={{ ml: 1 }} onClick={() => dispatch(toggleUploadDialog())} variant='contained' endIcon={
                    <CloudDownload />
                  }>Attachments
                  </Button>
                </Badge>
              </Box>
            </Grid> */}


            {/* Configuration */}
            {/* <Grid item xs={12} sm={5.67}>
              <Box display='flex' alignItems='center' mt={1}>
                <RadioFormBool label='Please confirm that you agree with the 60-days payment:'
                  control={control} value1={true} label1='Yes'
                  value2={false} label2='No'
                  errors={errors} dynamicField='agreeWithDefaultDays' required={false} />
              </Box>

              <TextForm label='Credit Days' dynamicField='creditDays'
                control={control} errors={errors}
                required={true}
                type='number'
                min={1} max={3}
                disabled={disabled}
              />
            </Grid> */}

            {!individualBool && <Grid item xs={12} sm={5.67}>
              <Box display='flex' alignItems='center' >
                <Typography mr={1}>{t('company_logo')}</Typography>
                <Badge badgeContent={companyLogo?.filter((x) => x.type === 0)?.length} color="error">
                  <Button size='small' onClick={() => setOpenAttachmentDialog(true)} variant='contained' endIcon={
                    <CloudDownload />
                  }>{t('attachments')}</Button>
                </Badge>
              </Box>
            </Grid>
            }
          </Grid >
        </form>
        <SaveDialog handleSave={handleSubmit(onSubmit)} text='Supplier Evaluation' />
        <CompanyDealerAttachment
          module={'Vendors'}
          value={attachmentsDealership}
          setValue={setAttachmentsDealership}
          initialData={attachmentsDealership}
        />
        <CompanyLogoAttachment
          nameKey='companyLogo'
          open={openAttachmentDialog}
          setOpen={setOpenAttachmentDialog}
          module={'Vendors'}
          value={companyLogo}
          setValue={setCompanyLogo}
          initialData={companyLogo}
        />
      </>) : <><SupLoading /></>}


      <div>
        <Dialog open={taxDialog}>
          <DialogTitle>{t('taxModalTitle1')}</DialogTitle>
          <Divider />
          <DialogContent>
            <Box>
              {t('taxModalTitle2')}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={handleYesTax}>
              {t('yes')}
            </Button>
            <Button variant="outlined" onClick={handleTaxCloseDialog} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
              {t('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  )
}